import React from 'react'
import { Panel } from 'src/Components'
import Headline from './Headline'
import PaidSoFar from './PaidSoFar'
import StatusExplainer from './StatusExplainer'
import RefiByYearsInHome from './RefiByYearsInHome'
import PrincipalPayments from './PrincipalPayments'
import Info from './Info'

const Interest = () => (
  <Panel data-qa='InterestCard'>
    <Headline />
    <PaidSoFar />
    <StatusExplainer />
    <RefiByYearsInHome />
    <PrincipalPayments />
    <Info />
  </Panel>
)

export default Interest
